import classNames from "classnames";
import { useEffect, useState } from "react";

const Loading = ({ text, size, classname }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
  }, [text]);
  useEffect(() => {
    if (text) {
      setTimeout(() => {
        if (count + 1 < text.length) {
          setCount(count + 1);
        }
      }, 3200);
    }
  }, [count]);

  return (
    <>
      <div className={classNames("loader", classname, `loader--${size}`)}></div>
      {text && <div className="loader__text">{text[count]}</div>}
    </>
  );
};

export default Loading;
